import { all } from "redux-saga/effects"

import currentUserSaga from "./current-user/current-user.saga"
import toolsSaga from "./tools/tools.saga"

export default function* rootSaga() {
  yield all([toolsSaga(), currentUserSaga()])
}
